/* ── FARIMAN CART JS ── */
(function() {
  'use strict';

  // ─ Quantity controls ─
  document.addEventListener('click', function(e) {
    if (e.target.matches('[data-qty-decrease]')) {
      var input = e.target.closest('.fariman-quantity__control').querySelector('.fariman-quantity__input');
      var val = parseInt(input.value, 10);
      if (val > 1) input.value = val - 1;
    }
    if (e.target.matches('[data-qty-increase]')) {
      var input = e.target.closest('.fariman-quantity__control').querySelector('.fariman-quantity__input');
      var val = parseInt(input.value, 10);
      input.value = val + 1;
    }
  });

  // ─ Add to cart ─
  var atcForms = document.querySelectorAll('[data-fariman-atc-form]');
  atcForms.forEach(function(form) {
    form.addEventListener('submit', function(e) {
      e.preventDefault();
      var btn = form.querySelector('.fariman-atc-btn');
      if (!btn || btn.disabled) return;

      btn.classList.add('is-loading');
      btn.disabled = true;
      var originalText = btn.querySelector('.fariman-atc-text');
      if (originalText) originalText.textContent = 'Ajout en cours...';

      var formData = new FormData(form);

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Accept': 'application/json' },
        body: formData
      })
      .then(function(r) { return r.json(); })
      .then(function(item) {
        btn.classList.remove('is-loading');
        btn.disabled = false;
        if (originalText) originalText.textContent = 'Ajouter au Panier';

        // Show notification
        showCartNotice(item.title || 'Produit ajouté');

        // Update cart count
        updateCartCount();

        // Success state briefly
        btn.style.background = '#2A6B2A';
        if (originalText) originalText.textContent = '✓ Ajouté au panier !';
        setTimeout(function() {
          btn.style.background = '';
          if (originalText) originalText.textContent = 'Ajouter au Panier';
        }, 2500);
      })
      .catch(function(err) {
        btn.classList.remove('is-loading');
        btn.disabled = false;
        if (originalText) originalText.textContent = 'Erreur — Réessayer';
        console.error('Cart error:', err);
      });
    });
  });

  // ─ Variant selection ─
  document.addEventListener('click', function(e) {
    if (e.target.matches('.fariman-variant-btn')) {
      var group = e.target.closest('.fariman-variants__options');
      group.querySelectorAll('.fariman-variant-btn').forEach(function(b) { b.classList.remove('is-selected'); });
      e.target.classList.add('is-selected');

      // Update hidden variant input
      var form = e.target.closest('form');
      if (form) {
        var variantInput = form.querySelector('[name="id"]');
        if (variantInput && e.target.dataset.variantId) {
          variantInput.value = e.target.dataset.variantId;
        }
      }
    }
  });

  // ─ Gallery thumbs ─
  document.addEventListener('click', function(e) {
    if (e.target.closest('.fariman-gallery__thumb')) {
      var thumb = e.target.closest('.fariman-gallery__thumb');
      var gallery = thumb.closest('.fariman-gallery');
      var mainImg = gallery.querySelector('.fariman-gallery__main img');
      var src = thumb.dataset.src;
      if (mainImg && src) {
        mainImg.src = src;
        gallery.querySelectorAll('.fariman-gallery__thumb').forEach(function(t) { t.classList.remove('is-active'); });
        thumb.classList.add('is-active');
      }
    }
  });

  // ─ FAQ accordion ─
  document.addEventListener('click', function(e) {
    if (e.target.closest('.fariman-faq__question')) {
      var item = e.target.closest('.fariman-faq__item');
      var isOpen = item.classList.contains('is-open');
      document.querySelectorAll('.fariman-faq__item.is-open').forEach(function(i) { i.classList.remove('is-open'); });
      if (!isOpen) item.classList.add('is-open');
    }
  });

  // ─ Accordion ─
  document.addEventListener('click', function(e) {
    if (e.target.closest('.fariman-accordion__trigger')) {
      var item = e.target.closest('.fariman-accordion__item');
      item.classList.toggle('is-open');
    }
  });

  // ─ Cart notification ─
  function showCartNotice(title) {
    var notice = document.getElementById('fariman-cart-notice');
    if (!notice) return;
    var nameEl = notice.querySelector('.fariman-cart-notice__name');
    if (nameEl) nameEl.textContent = title;
    notice.classList.add('is-visible');
    setTimeout(function() { notice.classList.remove('is-visible'); }, 4000);
  }

  document.addEventListener('click', function(e) {
    if (e.target.matches('.fariman-cart-notice__close')) {
      document.getElementById('fariman-cart-notice').classList.remove('is-visible');
    }
  });

  // ─ Update cart count badge ─
  function updateCartCount() {
    fetch('/cart.js')
    .then(function(r) { return r.json(); })
    .then(function(cart) {
      var badges = document.querySelectorAll('[data-cart-count]');
      badges.forEach(function(b) { b.textContent = cart.item_count; });
    });
  }

})();
